import { render, staticRenderFns } from "./CampaignsKeywordsGridContent.vue?vue&type=template&id=d1822392"
import script from "./CampaignsKeywordsGridContent.vue?vue&type=script&lang=ts"
export * from "./CampaignsKeywordsGridContent.vue?vue&type=script&lang=ts"
import style0 from "./CampaignsKeywordsGridContent.vue?vue&type=style&index=0&id=d1822392&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports